<template>
  <div class="textarea-wrapper" :class="{ 'has-error': error }">
    <textarea
      ref="actualInput"
      v-model="internalValue"
      class="textarea-input"
      @input="onChange(internalValue)"
      rows="1"
      :style="{ minWidth: minWidth ? minWidth + 'px' : 'auto' }"
    ></textarea>
    <div :class="['v-input__details', { 'invisible': !error }]" role="alert" aria-live="polite">
      <div class="v-messages">
        <div class="v-messages__message" v-for="(msg, i) in errorMessages" :key="i">{{ msg }}</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'
import _ from 'lodash'

const props = defineProps({
  modelValue: [String, Number],
  rules: Array,
  minWidth: Number,
  type: {
    type: String,
    default: 'text'
  }
})

const emit = defineEmits(['submit', 'formIsInvalid'])

const internalValue = ref(null)
const errorMessages = ref([])
const error = ref(false)
const actualInput = ref(null)
const debounceSubmit = _.debounce(submit, 300)

function validate(val = null) {
  if (val === null) {
    val = internalValue.value
  }
  errorMessages.value = []

  for (const rule of props.rules || []) {
    let result
    try {
      result = rule(val)
    } catch (e) {
      result = e.message || 'Validation error'
    }

      if (result !== true) {
      error.value = true
      errorMessages.value.push(result)
      emit('formIsInvalid')
      return false
      }
    }

  error.value = false
  return true
}

function submit(val) {
  emit('submit', val)
}
function onChange(val) {
  debounceSubmit.cancel();
  if (validate(val)) {
    debounceSubmit(val)
  }
}
defineExpose({
  validate,
  focus() {
    actualInput.value.focus()
  },
  scrollIntoView(e) {
    actualInput.value.scrollIntoView(e)
  },
  resetValidation() {
    errorMessages.value = []
    error.value = false
  }
})

watch(() => props.modelValue, (val) => {
  internalValue.value = val
}, { immediate: true })
</script>

<style scoped>
.textarea-wrapper {
  display: flex;
  flex-direction: column;
  margin-bottom: 8px;
}
.textarea-label {
  font-size: 14px;
  margin-bottom: 4px;
  color: #555;
}
.textarea-input {
  padding: 8px;
  border: 1px solid rgba(0,0,0,0.12);
  border-radius: 4px;
  font-size: 14px;
  resize: vertical;
  min-height: 60px;
}
.textarea-input:focus {
  outline: none;
}
.has-error .textarea-input {
  border-color: #d32f2f;
}
</style>
